// Function to update the content in the target div
function formatIndianCurrency(amount) {
  let num = amount.toString();
  let lastThree = num.substring(num.length - 3);
  let otherNumbers = num.substring(0, num.length - 3);
  if (otherNumbers !== "") {
    lastThree = "," + lastThree;
  }
  // Adding commas to the rest of the string
  otherNumbers = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
  return otherNumbers + lastThree;
}

function updateContent() {
  // Get the element matching the selector
  var element = document.querySelector(
    ".product-right-content-sticky-inner .price-item"
  );

  if (element) {
    // Get the text content of the element
    var content = element.textContent;
    var numericString = content.replace("₹ ", "").replace(",", "");

    // Convert the numeric string to a number
    var originalAmount = parseFloat(numericString);

    // Calculate 2.5% of the original amount
    var percentageToAdd = originalAmount * 0.025;

    // Calculate the new amount after adding 2.5%

    var newAmount = Math.round(originalAmount + percentageToAdd);
    var formattedAmount = formatIndianCurrency(newAmount);
    var targetDiv = document.querySelector(".text-var-price-2");

    var amazonCurrentPriceSticky = document.querySelector(
      ".amazonCurrentPriceSticky"
    );
    var currentPriceSticky = document.querySelector(".currentPriceSticky");
    var amazonCurrentPrice3 = document.querySelector(".amazonCurrentPrice3");
    var currentPrice3 = document.querySelector(".currentPrice3");
    var amazonCurrentPriceBB = document.querySelector(".amazonCurrentPriceBB");
    var currentPriceBB = document.querySelector(".currentPriceBB");
    var currentPriceBBPrice = document.querySelector(".currentPriceBBPrice");
    var dif2 = document.querySelector(".dif2");
    var difBB = document.querySelector(".difBB2");
    var totalSaved = document.querySelector(".total-saved");
    var totalSavedBB = document.querySelector(".total-saved-with-buyback");

    if (targetDiv) {
      // Update the innerHTML of the target div with the content
      targetDiv.innerHTML = "₹ " + formattedAmount;
    }
    if (currentPrice3) {
      currentPriceSticky.innerHTML = parseInt(numericString);
      currentPrice3.innerHTML = parseInt(numericString);
      currentPriceBB.innerHTML = parseInt(numericString);
      currentPriceBBPrice.innerHTML = "₹ " + parseInt(0.5 * numericString);
    }
    if (amazonCurrentPrice3) {
      amazonCurrentPrice3.innerHTML = numericString;
      amazonCurrentPriceSticky.innerHTML = numericString;
      amazonCurrentPriceBB.innerHTML = numericString;
    }
    if (dif2) {
      dif2.innerHTML = numericString - numericString;
      difBB.innerHTML = numericString - numericString;
      totalSaved.innerHTML =
        "₹ " + parseInt(parseInt(dif2.textContent) + 1500 + 1909) + " Saved!";
      totalSavedBB.innerHTML =
        "₹ " +
        parseInt(
          parseInt(difBB.textContent) +
            1500 +
            1909 +
            0.5 * currentPriceBB.textContent
        ) +
        " Saved!";
    }
    console.log(
      difBB.textContent + "=====================difBB========================="
    );
  }
}

function toggleRadio() {
  console.log("called===============================");
  const buybackTextSticky = document.querySelector(".buyback-text-sticky");
  const buybackRow = document.querySelector(".buyback-row");
  var savingResult = document.querySelector(".saving-result");
  var amazonCurrentPriceSticky = document.querySelector(
    ".amazonCurrentPriceSticky"
  );
  var currentPriceSticky = document.querySelector(".currentPriceSticky");
  var content1 = amazonCurrentPriceSticky.textContent;
  var content2 = currentPriceSticky.textContent;
  var numACP = parseInt(content1);
  var numCP = parseInt(content2);
  var withoutBuyback = numACP - numCP + 1500 + 1909;
  var withBuyback = numACP - numCP + 1500 + 1909 + numCP * 0.5;
  savingResult.style.display = "flex";
  buybackTextSticky.style.display = "inline-block"; // Show the buyback text
  buybackRow.style.display = "none";
  buybackTextSticky.innerHTML = "₹" + withoutBuyback;
}

// Function to create and configure the MutationObserver
function setupObserver2() {
  // Select the element to observe
  var targetNode = document.querySelector(
    ".product-right-content-sticky-inner .price-item"
  );

  if (!targetNode) return;
  // Callback function to execute when mutations are observed
  var observerCallback = function (mutationsList, observer) {
    for (var mutation of mutationsList) {
      if (mutation.type === "childList" || mutation.type === "characterData") {
        // Update content when mutation detected
        updateContent();
        toggleRadio();

        break; // Assuming you only need to update once per mutation
      }
    }
  };

  // Create an observer instance
  var observer = new MutationObserver(observerCallback);

  // Configuration of the observer
  var config = { subtree: true, childList: true, characterData: true };

  // Start observing the target node for configured mutations
  observer.observe(targetNode, config);

  // Initial update
  updateContent();
  toggleRadio();
}

// Run setupObserver function when DOM content is loaded
document.addEventListener("DOMContentLoaded", function () {
  setupObserver2();
});

// Modal
document.addEventListener("DOMContentLoaded", function () {
  const knowHowLink2 = document.querySelector(".saving-result a");
  const calcParent = document.querySelector(".calc-parent-2");
  const modal2 = document.getElementById("infoModal2");
  const closeModalBtn2 = document.getElementById("closeModal2");

  knowHowLink2?.addEventListener("click", function (event) {
    event.preventDefault(); // Prevent default anchor behavior
    modal2.style.display = "block"; // Show the modal
  });
  // calcParent.addEventListener("click", function (event) {
  //   event.preventDefault(); // Prevent default anchor behavior
  //   modal2.style.display = "block"; // Show the modal
  // });

  closeModalBtn2?.addEventListener("click", function () {
    modal2.style.display = "none"; // Hide the modal
  });

  // Optional: Close the modal when clicking outside of it
  modal2?.addEventListener("click", function (event) {
    if (event.target === modal2) {
      modal2.style.display = "none"; // Hide the modal
    }
  });
});

function toggleTable(radio) {
  const withoutBB = document.getElementById("withoutBB");
  const withBB = document.getElementById("withBB");

  if (radio?.value === "1" && withoutBB && withBB) {
    withoutBB.style.display = "block";
    withBB.style.display = "none";
  } else {
    if (withoutBB) withoutBB.style.display = "none";
    if (withBB) withBB.style.display = "block";
  }
}

// Initial setup to ensure the correct div is displayed on page load
document.addEventListener("DOMContentLoaded", () => {
  toggleTable(document.querySelector('input[name="tableToggle"]:checked'));
});
